<template>
    <div>
        <div class="flex justify-between border-b border-grayxlight mb-3 ds-exchange-panel-section">
            <div>История изменений</div>
            <div class="ds-exchange-history-toggle" @click="togglePanel">
                <span v-if="isOpen">Свернуть</span>
                <span v-else>Развернуть</span>

            </div>
        </div>
        <div v-if="isOpen">
      <!-- Состояние загрузки -->
      <div v-if="isLoading" class="flex min-h-16 items-center justify-center py-4">
        <loader size="32"></loader>
      </div>

      <!-- Ошибка загрузки -->
      <div v-else-if="error" class="text-center py-4 text-red-500 text-sm">
        Ошибка загрузки истории: {{ error }}
      </div>

      <!-- Данные -->
      <VacancyHistoryList :history v-else />
    </div>
    </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs';
import { ref, computed } from 'vue'
import { useExchangeStore } from '@/stores/exchangeStore';
import utc from "dayjs/plugin/utc"
import VacancyHistoryList from './VacancyHistoryList.vue';

interface Props {
  vacancy: any
}

const { vacancy } = defineProps<Props>();

dayjs.extend(utc)

const store = useExchangeStore();
const isOpen = ref(false);
const isLoading = ref(false);
const error = ref<string | null>(null);

const history = computed(() => store.history)

// Функция переключения панели с логикой загрузки
const togglePanel = async () => {
  isOpen.value = !isOpen.value;

  // Загружаем данные только если панель открывается и ID смены доступен
  if (isOpen.value && vacancy.id) {
    await loadShiftHistory();
  }
};

// Отдельная функция для загрузки истории
const loadShiftHistory = async () => {
  if (!vacancy.id) return;

  isLoading.value = true;
  error.value = null;

  try {
    await store.fetchHistory(vacancy.id);
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'Неизвестная ошибка';
  } finally {
    isLoading.value = false;
  }
};


</script>
